var map = {
	"./1-Shri. Suman Talwar-Actor, Philanthropist.jpeg": 18057,
	"./2-Shri Mr Jawad A.J. -The Registrar IAMC, International arbitrator &  mediator.jpeg": 65145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31239;